import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { Item, ItemTree } from 'src/app/components/layout/forms/tree-view/tree-view.component';
import { CategoriesList, ReferenceParams, Res } from 'src/app/models';
import { NotificationService } from 'src/app/services';
import { ApiCategoriesService } from 'src/app/services/api-categories.service';

@Component({
  selector: 'app-access-to-categories',
  templateUrl: './access-to-categories.component.html',
  styleUrls: ['./access-to-categories.component.css']
})
export class AccessToCategoriesComponent implements OnInit {

  subscriptions: Subscription = new Subscription();
  progressRef: NgProgressRef;
  treeHeader: boolean = true;
  filteredCatgory: CategoriesList[] = [];
  myItems:any[] = [];
  items: ItemTree[] = [];
  categorieslength: number;
  itemsLoading: boolean;
  categoryType:string = 'categories';

  @Input() roleId;

  constructor(
    public ngProgress: NgProgress,
    private apiCategoriesService: ApiCategoriesService,
    private notification: NotificationService,
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.getCategories();
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  /**
   * 
   * @param value 
   */
  eventCategoryList(value: any): void {

    if (value.checked) {

      console.log("VALUE: ", value);

      this.items.push(value);

      this.onCreate(value.id);

    } else {

      let index = this.items.findIndex(val => val.id == value.id);

      this.items.splice(index, 1);

      this.onDelete(value.id);
    }

  }

  /**
   * 
   * @param searchValue - значение для поиска вводимое вручную
   * @param currentElemId - текущее значение из справочника передаваемое при его выборе из списка
   */
  getCategories(searchValue: string = '', currentElemId: any = ''): void {

    let params: ReferenceParams = {
      ref_name: 'categories_to_roles',
      filter: {
        urole_id: this.roleId
      }
    }

    this.itemsLoading = true;
    this.items = [];

    this.subscriptions.add(
      this.apiCategoriesService.getReferences(params, params.ref_name).subscribe((response: Res) => {

        console.log("USER CAT RESP: ", response);

        if (response != null) {

          this.myItems = [...response.result];


          this.generateCategoryTree(<Item[]>response.result);

        }
        this.itemsLoading = false;
      },
        error => {
          this.itemsLoading = false;
        })
    );
  }

  /**
   * 
   * @param categories 
   */
  generateCategoryTree(categories: Item[]): void {

    let categoryList: Item[] = [...categories];

    for (let category of categoryList) {

      if (this.searchForParentCategory(category, this.items)) {

        categories = categories.filter(val => val.id != category.id);
      }
    }

    if (categories.length > 0 && categories.length != this.categorieslength) {

      this.categorieslength = categories.length;
      this.generateCategoryTree(categories);
    }
  }

  /**
 * 
 * @param category Item
 * @param treeviewItems TreeviewItem[]
 * @returns boolean
 */
  searchForParentCategory(category: Item, treeviewItems: ItemTree[]): boolean {

    if (category.parent_id == null) {

      this.items = this.pushInTreeCategories(category, treeviewItems);

      return true;
    }

    for (let item of treeviewItems) {

      if (item.id == category.parent_id) {

        item.children = this.pushInTreeCategories(category, item.children);
        return true;
      }
      else {

        if (item.children != undefined) {

          if (this.searchForParentCategory(category, item.children)) {

            return true;
          }
        }
      }
    }

    return false;
  }

  /**
  * 
  * @param category Item
  * @param treeviewItems TreeviewItem[]
  * @returns TreeviewItem[]
  */
  pushInTreeCategories(category: Item, treeviewItems: ItemTree[]): ItemTree[] {


    let tvi: any[] = treeviewItems != undefined ? [...treeviewItems] : [];

    tvi.push(
      {
        checked: false,
        id: category.id,
        name: category.name,
        parent_id: category.parent_id,
        children: <ItemTree[]>[]
      }
    )

    return tvi;
  }

  /**
   * 
   * @param item 
   */
  onCreate(item_id) {

    let data = {
      urole_id: this.roleId,
      category_id: item_id
    }

    this.progressRef.start();
    this.itemsLoading = true;

    this.subscriptions.add(
      this.apiCategoriesService.createMyCategory(data).subscribe((response: Res) => {

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
        }

        this.progressRef.complete();
        this.itemsLoading = false;
      },
        error => {
          this.itemsLoading = false;
        })
    );

  }

  /**
  * 
  * @param ids 
  */
  onDelete(item_id: any): void {

    this.progressRef.start();
    this.itemsLoading = true;

    let data = {
      urole_id: this.roleId,
      category_id: item_id
    }

    this.subscriptions.add(
      this.apiCategoriesService.deleteMyCategory(data).subscribe(response => {

        if (response != null) {

          this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
        this.itemsLoading = false;
      })
    );
  }

}
